module.exports = __webpack_public_path__ + "img/2x.c6f75e9.jpg";